<template>
  <div class="wp_itemsContainer">
    <router-link
      tag="a"
      to="/login"
      v-if="!isAuthenticated"
      class="wp_mobileSignin"
						data-test="mobileHeaderElementsSignUpLink"
						id="mobileHeaderElementsSignUpLink"
    >
      Sign in
    </router-link>
    <!-- notification -->
    <!--<div class="wp_mobileNotification"  v-if="isAuthenticated">-->
    <!--<svg-->
    <!--version="1.1"-->
    <!--id="Capa_1"-->
    <!--xmlns="http://www.w3.org/2000/svg"-->
    <!--xmlns:xlink="http://www.w3.org/1999/xlink"-->
    <!--x="0px"-->
    <!--y="0px"-->
    <!--viewBox="0 0 416 416"-->
    <!--style="enable-background:new 0 0 416 416;"-->
    <!--xml:space="preserve"-->
    <!--&gt;-->
    <!--<g>-->
    <!--<g>-->
    <!--<g>-->
    <!--<path-->
    <!--d="M208,416c23.573,0,42.667-19.093,42.667-42.667h-85.333C165.333,
    396.907,184.427,416,208,416z"-->
    <!--&gt;</path>-->
    <!--<path-->
    <!--d="M336,288V181.333c0-65.6-34.88-120.32-96-134.827V32c0-17.707-
    14.293-32-32-32s-32,14.293-32,32v14.507-->
    <!--c-61.12,14.507-96,69.227-96,134.827V288l-42.667,
    42.667V352h341.333v-21.333L336,288z"-->
    <!--&gt;</path>-->
    <!--</g>-->
    <!--</g>-->
    <!--</g>-->
    <!--</svg>-->
    <!--<span class="cart-n wp_cartCountContainerNotification">-->
    <!--1-->
    <!--</span>-->
    <!--</div>-->
    <!-- notification -->

    <!-- cart -->
    <div
      class="wp_cartButtonMobileTab"
      v-if="$route.path !== '/cart' &&
                $route.path !== '/order-success' &&
                !($route.query.token)"
    >
      <span
        class="wp_cartIconSpan"
        aria-expanded="false"
        @click="$router.push({
                       path :'/cart',
                        query: {
                              display_text: 'My Cart',
                            }
                       })"
								data-test="mobileHeaderElementsCartSpan"
								id="mobileHeaderElementsCartSpan"
      >
        <svg
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          class="wp_SVGCart"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 510 510"
          style="enable-background:new 0 0 510 510;"
          xml:space="preserve"
										data-test="mobileHeaderElementsCartSvg"
										id="mobileHeaderElementsCartSvg"
        >
          <g>
            <g id="shopping-cart">
              <path d="M153,408c-28.05,0-51,22.95-51,51s22.95,51,51,
                51s51-22.95,51-51S181.05,408,153,408z M0,0v51h51l91.8,
                193.8L107.1,306
                  c-2.55,
                  7.65-5.1,17.85-5.1,25.5c0,28.05,22.95,51,51,
                  51h306v-51H163.2c-2.55,0-5.1-2.55-5.1-5.1v-2.551l22.95-43.35h188.7
                  c20.4,0,35.7-10.2,43.35-25.5L504.9,89.25c5.1-5.1,5.1-7.65,
                  5.1-12.75c0-15.3-10.2-25.5-25.5-25.5H107.1L84.15,0H0z M408,
                  408 c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,
                  51-51S436.05,408,408,408z">
              </path>
            </g>
          </g>
        </svg>
      </span>
      <span
        class="cart-n wp_cartCountContainer"
        id="mobileHeader-cart-count"
        v-show="getCartCount > 0"
								data-test="mobileHeaderElementsCountSpan"
      >
        {{getCartCount}}
      </span>
    </div>
    <!-- cart -->
    <!-- profile -->
    <div
      class="wp_userIconMobileTab"
      v-if="isAuthenticated"
      @click.prevent="$router.push({
                         path :'/user/account',
                          query: {
                                display_text: 'My Account',
                              }
                         })"
						data-test="mobileHeaderElementsAccount"
						id="mobileHeaderElementsAccount"
    >
      <svg
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="409.165px"
        height="409.164px"
        viewBox="0 0 409.165 409.164"
        style="enable-background:new 0 0 409.165 409.164;"
        xml:space="preserve"
								data-test="mobileHeaderElementsAccountSvg"
								id="mobileHeaderElementsAccountSvg"
      >
        <g>
          <g>
            <path d="M204.583,216.671c50.664,0,91.74-48.075,
            91.74-107.378c0-82.237-41.074-107.377-91.74-107.377 c-50.668,0-91.74,
            25.14-91.74,107.377C112.844,168.596,
            153.916,216.671,204.583,216.671z">
            </path>
            <path d="M407.164,374.717L360.88,270.454c-2.117-4.771-5.836-8.728-10.465-11.138l-71.83-37.392 c-1.584-0.823-3.502-0.663-4.926,0.415c-20.316,15.366-44.203,23.488-69.076,23.488c-24.877,0-48.762-8.122-69.078-23.488 c-1.428-1.078-3.346-1.238-4.93-0.415L58.75,259.316c-4.631,2.41-8.346,6.365-10.465,11.138L2.001,374.717 c-3.191,
            7.188-2.537,15.412,1.75,22.005c4.285,6.592,11.537,10.526,19.4,
            10.526h362.861c7.863,0,15.117-3.936,19.402-10.527
            C409.699,390.129,410.355,381.902,407.164,374.717z">
            </path>
          </g>
        </g>
      </svg>
    </div>
    <!-- profile -->
  </div>
</template>
<script>
// import CartButton from '@/components/shared/widgets/CartButton'
import { mapGetters } from 'vuex'

export default {
	// components: {
	//   // CartButton
	// },
	computed: {
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('cart', ['getCartCount'])
	}
}
</script>
